import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  socket: null,
  loadingScreen: false,
  appGlobal: null
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    onSetUser: (state, action) => {
      state.user = action.payload;
    },
    onLoadingScreen: (state, action) => {
      state.loadingScreen = action.payload;
    },
    onSetAppGlobal:(state, action) => {
      state.appGlobal = action.payload;
    },
  },
});

export const { onSetUser, onLoadingScreen,onSetAppGlobal } = appSlice.actions;

export default appSlice.reducer;
